// extracted by mini-css-extract-plugin
export var root = "F_vB";
export var wrapper = "F_vC";
export var image = "F_vD d_w d_y d_W";
export var imageWithHeight = "F_vF";
export var crop = "F_vG";
export var round = "F_vH";
export var fixedHeight = "F_vJ";